import React, { useCallback } from 'react';
import {
  makeStyles,
  Theme,
  useMediaQuery,
  useTheme,
  Card,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { IconButton, Switch, Typography } from '@thingsw/pitta-design-system';
import clsx from 'clsx';
import { TabNameInfo3, Webviewer, TrueFalsetype } from '@thingsw/pitta-modules';

const useStyles = makeStyles((theme: Theme) => ({
  flex: {
    display: 'flex',
    alignItems: 'center',
  },

  card: {
    display: 'flex',
    maxWidth: 673,
    minHeight: 49,
    alignItems: 'center',
    borderRadius: 12,
    marginBottom: theme.spacing(1) - 1,
    boxShadow: '0px 2px 2px 0px rgb(0 0 0 / 6%)',
    padding: '11px 23px 12px',
  },

  switch: {
    marginRight: 20,
    display: 'flex',
    alignItems: 'center',
  },
}));

interface SystemVoiceGuidancePanelProps {
  onClose: () => void;
  currentTab3?: TabNameInfo3;
  onChange: (key: keyof TabNameInfo3, val: boolean) => void;
}

export const SystemVoiceGuidancePanel = ({
  onClose,
  currentTab3,
  onChange,
}: SystemVoiceGuidancePanelProps) => {
  const classes = useStyles();
  const theme = useTheme() as Theme;
  const mobile = useMediaQuery(theme.breakpoints.down(Webviewer.mobile));
  const { t } = useTranslation();

  const getBoolean = (TrueFalse: TrueFalsetype) => {
    return TrueFalse === '1' ? true : false;
  };

  const renderSimpleSwitch = useCallback(
    (label: string, key: keyof TabNameInfo3) => {
      return (
        <Card variant='outlined' className={clsx(classes.card)}>
          <div className={classes.switch}>
            <Switch
              checked={getBoolean((currentTab3?.[key] as TrueFalsetype) ?? '1')}
              onChange={(e) => {
                onChange(key, e.target.checked);
              }}
            />
          </div>
          <div>
            <Typography
              category='Default'
              variant='Body'
              style={{ marginBottom: mobile ? 3 : 2 }}
            >
              {t(label)}
            </Typography>
          </div>
        </Card>
      );
    },
    [classes.card, classes.switch, currentTab3, mobile, onChange, t]
  );

  return (
    <>
      <div className={classes.flex} style={{ marginBottom: 14 }}>
        <div>
          <IconButton
            style={{ marginRight: 7 }}
            onClick={() => {
              onClose();
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>
        </div>
        <Typography category='Default' variant='H6'>
          {t('System voice guidance')}
        </Typography>
      </div>
      {renderSimpleSwitch('Power on', 'STARTVOICE')}
      {renderSimpleSwitch(
        'Starting normal recording',

        'NORMALSTARTVOICE'
      )}
      {/* mantis - 11089, 문구 펌웨어 설정표 기준으로 수정 Start event recording (beep) -> Starting Event Recording (Beep) (Leehj) */}
      {renderSimpleSwitch('Changing recording mode', 'CHANGERECORDMODEVOICE')}
      {renderSimpleSwitch('Settings have been changed', 'CHANGECONFIGVOICE')}
      {renderSimpleSwitch('Power off', 'ENDVOICE')}
      {renderSimpleSwitch('Cloud related', 'CLOUDVOICE')}
    </>
  );
};
